import HandlerAbstract from "./HandlerAbstract";

export default class PostViewedHandler extends HandlerAbstract {
    getEventHandlers() {
        return ["post.viewed"];
    }

    handle(event) {
        const storyId = event.detail.storyId;

        this._analytics.pubSub.publish("postViewed", {
            "storyId": storyId,
        });

        return false;
    }
}
